module.exports = __webpack_public_path__ + "img/elec.7908e80.gif";